import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface InterrogationStopRecordingDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function InterrogationStopRecordingDialog({
  open,
  onCancel,
  onConfirm,
}: InterrogationStopRecordingDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Stop recording?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Transcription will pause. Any speech captured so far stays in the transcript.
          You can start recording again later.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} sx={{ textTransform: 'none' }}>
          Keep recording
        </Button>
        <Button
          variant="contained"
          color="warning"
          onClick={onConfirm}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Stop recording
        </Button>
      </DialogActions>
    </Dialog>
  );
}
